<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF EDUCATION & SPORTS</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">ABOUT US</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool01/14.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">Introduction</h2>
                <p>The ARNI School of Education and Sports is a combination of teaching physical education with science.
                    We believe that education is not just limited to academic achievements but also fosters holistic
                    development through physical fitness, mental well-being, and team spirit. The school is completely
                    dedicated to preparing future educators and sports professionals who can inspire and honor the
                    nation,lead integrity and passion. With a team of focused and well-established educators, our goal
                    is to provide contemporary pedagogies, inclusive education, and advanced sports training. We are the
                    best physical education colleges in india among others.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision</b> – Our vision is to create well-educated and decent sports professionals who honor not
                    only us
                    but the entire nation with their exceptional gaming spirit that blends with ethics and sports
                    spirit. We would like to count among the globally recognized centers of excellence in education and
                    sports.
                </p>
                <p><b>Mission </b> – Our mission is to deliver innovative and inclusive educational programs that foster
                    intellectual growth, creativity, and critical thinking. We are on a mission to develop world-class
                    sports professionals equipped with relevant skills and knowledge.
                </p>
                <h2>Bachelors degree in physical education</h2>
                <p>Bachelor of Physical Education and Sports colleges emphasize comprehensive training for students to
                    achieve academic success and develop athletic qualities. The school's faculty, including subject
                    matter experts, provide innovative teaching methods and personalized instruction, preparing students
                    for both academic and professional careers. The school also provides sports areas, skilled coaching
                    staff, and state-of-the-art facilities. The school believes in the power of education to transform
                    lives and cultivate well-rounded individuals ready to contribute positively to society.
                </p>
                <p><b>Scope </b> - The ARNI School of Education & Sports offers immense opportunities for aspiring
                    educators and
                    sports professionals to carve successful careers while contributing to societal progress with a
                    bachelor of physical education and sports.
                </p>
                <ul>
                    <li>Equipping students to contribute to curriculum design, policy formulation, and educational
                        research.
                    </li>
                    <li>Developing athletes with the skills, discipline, and strategy to compete nationally and
                        internationally.
                    </li>
                    <li>Training professionals to address injuries and promote recovery through specialized
                        rehabilitation techniques.
                    </li>
                </ul>
                <p>The skills gained at the ARNI School of Education & Sports are transferable, empowering students to
                    excel in diverse fields, including education, sports science, and leadership roles in corporate and
                    community settings. Join us now and explore the world of fitness and sports for better career
                    opportunities.
                </p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">1</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">2</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">1</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Sports</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BPES</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
